import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import BackArrow from '@material-ui/icons/ArrowBackIos';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import ImportRecipientsStatus from './ImportRecipientsStatus';
import './Recipients.css';
import styles from './Recipients.style';
import { db, getUser, redirectToRoot } from '../../utilities/firebase-config';

const RecipientsList = ({ recipients }) => recipients.map(recipient => (
  <Link to={ `/recipient/${recipient.number}` } key={ recipient.number }>
    <ListItem button divider>
      <ListItemText
        primary={ recipient.name }
        secondary={ recipient.formattedNumber }
      />
      <ListItemSecondaryAction>
        <IconButton aria-label="Details">
          <ChevronRightIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  </Link>
));

class Recipients extends Component {
  state = {
    recipients: [],
    showImportStatus: true,
  };

  async componentDidMount() {
    const { history } = this.props;
    const user = await getUser();

    if (!user || !user.profile || user.profile.permissions !== 'Administrator') {
      redirectToRoot(history);
    }

    db.ref('notifyList').on('value', (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const keys = Object.keys(data);
        const recipients = keys.map((key) => {
          const phone = key.replace('+1', '').split('');
          return {
            added: data[key].added,
            formattedNumber: `(${phone[0]}${phone[1]}${phone[2]}) ${phone[3]}${phone[4]}${phone[5]}-${phone[6]}${phone[7]}${phone[8]}${phone[9]}`,
            name: data[key].name,
            number: key,
          };
        });

        recipients.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          } if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        });

        this.setState({
          recipients,
        });
      }
    });
  }

  componentWillUnmount() {
    db.ref('notifyList').off();
  }

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  closeImportStatus = () => {
    this.setState({
      showImportStatus: false,
    });
  }

  render() {
    const { classes } = this.props;
    const { location: { search } } = this.props;
    const { recipients, showImportStatus } = this.state;
    let importRecipientsKey = null;

    if (search.indexOf('importRecipientsKey') !== -1) {
      const searchParams = search.replace('?', '').split('&');
      const importRecipientsKeyParam = searchParams.find(param => param.indexOf('importRecipientsKey') > -1);

      [, importRecipientsKey] = importRecipientsKeyParam.split('=');
    }

    // TODO : https://github.com/clauderic/react-tiny-virtual-list

    return (
      <div className="Recipients container">

        <AppBar position="fixed" color="primary">
          <Toolbar>
            <IconButton className={ classes.menuButton } color="inherit" aria-label="Go Back" onClick={ this.goBack }>
              <BackArrow />
            </IconButton>
            <Typography variant="h6" color="inherit" className={ classes.grow }>
              Notify List
            </Typography>
            <Link to="/recipient/new">
              <IconButton aria-label="Add Recipient" className={ classes.addButton }>
                <AddIcon />
              </IconButton>
            </Link>
          </Toolbar>
        </AppBar>

        <div className={ classes.root }>
          { importRecipientsKey && showImportStatus
            && (
              <ImportRecipientsStatus
                importRecipientsKey={ importRecipientsKey }
                close={ this.closeImportStatus }
              />
            )
          }
          <List component="nav">
            <RecipientsList recipients={ recipients } />
          </List>
        </div>
      </div>
    );
  }
}

Recipients.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withStyles(styles)(Recipients);
